import { render, staticRenderFns } from "./RoutesFeed.vue?vue&type=template&id=25ea896f&"
import script from "./RoutesFeed.vue?vue&type=script&lang=ts&"
export * from "./RoutesFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports